import adresseGenerer from '@/services/general/genererAdresse';
import genererModeReglement from '@/services/general/genererModeReglement';
import genererDelaiReglement from '@/services/parametrage/generation/genererDelaiReglement';
import genererDelaiReglementDetail from '@/services/parametrage/generation/genererDelaiReglementDetail';
import genererModeCalculHonoraire from '@/services/commun/tiers/genererModeCalculHonoraire';
import { TYPOLOGIE_AUCUN, APPLICATION_TVA_TYPE_NORMAL } from '@/configuration/tiers/tiersConf';

export default function generer() {
  const adressePostale = adresseGenerer();
  const adresseFacturation = adresseGenerer();
  const modeReglement = genererModeReglement();
  const delaiReglement = genererDelaiReglement();
  const delaiReglementDetail = genererDelaiReglementDetail();
  return {
    nomCommercial: '',
    nomJuridique: '',
    siret: '',
    ape: '',
    tvaIntracommunautaire: '',
    secteurActiviteId: null,
    telephone: '',
    portable: '',
    email: '',
    siteWeb: '',
    adressePostale: adressePostale,
    adresseFacturation: adresseFacturation,
    contacts: [],
    rib: {
      banque: '',
      iban: '',
      bic: '',
      titulaire: '',
    },
    modeReglementId: null,
    modeReglement: modeReglement,
    delaiReglementId: null,
    delaiReglement: delaiReglement,
    delaiReglementDetail: delaiReglementDetail,
    compteComptable: '',
    commentairesBonDeCommandes: '',
    commentairesFacturation: '',
    commentairesInternes: '',
    blocageReglement: false,
    motifBlocageId: null,
    piecesJointes: [],
    adresseFacturationDifferente: false,
    archive: false,
    nombreJourDecalage: null,
    finDeMois: null,
    jourFinDeMois: null,
    companyId: 0,
    typologie: TYPOLOGIE_AUCUN,
    tiersParentId: null,
    prenom: null,
    nom: null,
    sousTypes: null,
    type: null,
    typePointVenteId: null,
    codeMagasin: null,
    factureParMail: false,
    applicationTva: APPLICATION_TVA_TYPE_NORMAL,
    prospect: false,
    role: null,
    portail: false,
    nombreMoisPreavis: null,
    modeCalculHonoraire: genererModeCalculHonoraire(),
    referenceUniqueMandat: null,
    moisDebutPeriodeBudgetaire: null,
    moisFinPeriodeBudgetaire: null,
    dateSignatureMandatSepa: null,
    estMairie: true,
    dateNaissance: null,
    nomJeuneFille: null,
    pourcentageRetrocession: null,
    referenceExterne: null,
    domTom: false,
    numeroCedant: '',
    numeroFichier: null,
    tiersMarques: [],
    lieuStockage: false,
    commentaireFactor: '',
    dateAnniversaireContrat: null,
    factorId: null,
    tags: [],
    competencesFournisseur: [],
  };
}
